<div class="driver-documents flex-column d-flex gap-4 " *transloco="let t; prefix: 'driverDocuments'">
  <div class="row  driver-documents__header align-items-center">
    <div class="col-lg-7 col-md-12 align-self-center">
      <h2 class="h3 m-0">{{ t('title') }}</h2>
    </div>
    <div class="col-lg-5">
      <div class="d-flex gap-2 justify-content-end align-content-center">
        <app-search [placeholder]="t('searchPlaceholder')" (searchTermUpdated)="onSearchTermUpdate($event)" [disabled]="isSearchDisabled" [customWidth]="'300px'"></app-search>
      </div>
    </div>
  </div>
  @if (!listLoaded || !detailsLoaded) {
    <div class="spinner-overlay">
      <div class="d-flex align-items-center justify-content-center spinner-border"></div>
    </div>
  }
  @if (!isSearching && !hasDrivers() && listLoaded && detailsLoaded) {
    <div class="d-flex no-drivers-container">
      <div class="no-drivers-icon">
        <img src="assets\icons\exclamation_circle.svg" alt="no-drivers-image">
      </div>
      <p class="no-drivers-message">{{ t('noDrivers') }}</p>
    </div>
  }
  @if (isSearching && !hasDrivers() && listLoaded && detailsLoaded) {
    <div class="d-flex driver-not-found-container">
      <div class="no-drivers-icon">
        <img src="assets\icons\exclamation_circle.svg" alt="no-drivers-image">
      </div>
      <p class="driver-not-found-message">{{ t('driverNotFound') }}</p>
    </div>
  }
  <div class="d-flex documents-details"
    [ngClass]="{'no-drivers': !hasDrivers(), 'd-none': !listLoaded || !detailsLoaded}"
    [ngStyle]="{'visibility': hasDrivers() ? 'visible' : 'hidden'}">
    <div class="col-auto documents-details__list">
      <app-driver-documents-list (loaded)="listLoaded = $event" [hasDrivers]="hasDrivers" (driverId)="driverId"></app-driver-documents-list>
    </div>
    <div class="flex-grow-1 documents-details__content">
      <app-driver-documents-details (loaded)="detailsLoaded = $event" [driverId]="driverId" [hasDrivers]="hasDrivers"></app-driver-documents-details>
    </div>
  </div>
</div>